// Models
import { JobCommentDefaultDto } from '../models/job-comment-default-dto';
import { JobCommentDefaultGroupDto } from '../models/job-comment-default-group-dto';
import { JobCommentDefaultLinkDto } from '../models/job-comment-default-link-dto';
import { JobCommentDefaultResponseAllDto } from '../models/job-comment-default-response-all-dto';

export namespace CommentDataActions {
	export class GetAll {
		static readonly type = '[Comment] Get Comments';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[Comment] Set Comment Data';
		constructor(public data: JobCommentDefaultResponseAllDto) {}
	}

	export class CreateCommentDefaultGroup {
		static readonly type = '[Comment] Create Comment Default Group';
		constructor(public data: { commentDefaultGroup: JobCommentDefaultGroupDto; showSpinner?: boolean; showToast?: boolean } = { commentDefaultGroup: null, showSpinner: false, showToast: false }) {}
	}

	export class CreateCommentDefaultGroupSuccess {
		static readonly type = '[Comment] Create Comment Default Group Success';
		constructor(public commentData: JobCommentDefaultResponseAllDto) {}
	}

	export class CreateCommentDefaultGroupError {
		static readonly type = '[Comment] Create Comment Default Group Error';
	}

	export class UpdateCommentDefaultGroup {
		static readonly type = '[Comment] Update Comment Default Group';
		constructor(public data: { commentDefaultGroup: JobCommentDefaultGroupDto; showSpinner?: boolean; showToast?: boolean } = { commentDefaultGroup: null, showSpinner: false, showToast: false }) {}
	}

	export class UpdateCommentDefaultGroupSuccess {
		static readonly type = '[Comment] Update Comment Default Group Success';
		constructor(public commentData: JobCommentDefaultResponseAllDto) {}
	}

	export class UpdateCommentDefaultGroupError {
		static readonly type = '[Comment] Update Comment Default Group Error';
	}

	export class DeleteCommentDefaultGroup {
		static readonly type = '[Comment] Delete Comment Default Group';
		constructor(public data: { commentDefaultGroup: JobCommentDefaultGroupDto; showSpinner?: boolean; showToast?: boolean; showConfirm: boolean } = { commentDefaultGroup: null, showSpinner: false, showToast: false, showConfirm: false }) {}
	}

	export class DeleteCommentDefaultGroupSuccess {
		static readonly type = '[Comment] Delete Comment Default Group Success';
		constructor(public commentData: JobCommentDefaultResponseAllDto) {}
	}

	export class DeleteCommentDefaultGroupError {
		static readonly type = '[Comment] Delete Comment Default Group Error';
	}

	export class UpdateCommentDefaultGroupSequence {
		static readonly type = '[Comment] Update Comment Default Group Sequence';
		constructor(public data: { commentDefaultGroups: JobCommentDefaultGroupDto[]; showSpinner?: boolean; showToast?: boolean } = { commentDefaultGroups: null, showSpinner: false, showToast: false }) {}
	}

	export class CreateCommentDefault {
		static readonly type = '[Comment] Create Comment Default';
		constructor(public data: { commentDefault: JobCommentDefaultDto; showSpinner?: boolean; showToast?: boolean } = { commentDefault: null, showSpinner: false, showToast: false }) {}
	}

	export class CreateCommentDefaultSuccess {
		static readonly type = '[Comment] Create Comment Default Success';
		constructor(public commentData: JobCommentDefaultResponseAllDto) {}
	}

	export class CreateCommentDefaultError {
		static readonly type = '[Comment] Create Comment Default Error';
	}

	export class UpdateCommentDefault {
		static readonly type = '[Comment] Update Comment Default';
		constructor(public data: { commentDefault: JobCommentDefaultDto; showSpinner?: boolean; showToast?: boolean } = { commentDefault: null, showSpinner: false, showToast: false }) {}
	}

	export class UpdateCommentDefaultSuccess {
		static readonly type = '[Comment] Update Comment Default Success';
		constructor(public commentData: JobCommentDefaultResponseAllDto) {}
	}

	export class UpdateCommentDefaultError {
		static readonly type = '[Comment] Update Comment Default Error';
	}

	export class DeleteCommentDefault {
		static readonly type = '[Comment] Delete Comment Default';
		constructor(public data: { commentDefault: JobCommentDefaultDto; showSpinner?: boolean; showToast?: boolean; showConfirm: boolean } = { commentDefault: null, showSpinner: false, showToast: false, showConfirm: false }) {}
	}

	export class DeleteCommentDefaultSuccess {
		static readonly type = '[Comment] Delete Comment Default Success';
		constructor(public commentData: JobCommentDefaultResponseAllDto) {}
	}

	export class DeleteCommentDefaultError {
		static readonly type = '[Comment] Delete Comment Default Error';
	}

	export class UpdateCommentDefaultSequence {
		static readonly type = '[Comment] Update Comment Default Sequence';
		constructor(public data: { commentDefaults: JobCommentDefaultDto[]; showSpinner?: boolean; showToast?: boolean } = { commentDefaults: null, showSpinner: false, showToast: false }) {}
	}

	export class CreateCommentDefaultLink {
		static readonly type = '[Comment] Create Comment Default Link';
		constructor(public data: { commentDefaultLink: JobCommentDefaultLinkDto; showSpinner?: boolean; showToast?: boolean } = { commentDefaultLink: null, showSpinner: false, showToast: false }) {}
	}

	export class CreateCommentDefaultLinkSuccess {
		static readonly type = '[Comment] Create Comment Default Link Success';
		constructor(public commentData: JobCommentDefaultResponseAllDto) {}
	}

	export class CreateCommentDefaultLinkError {
		static readonly type = '[Comment] Create Comment Default Link Error';
	}

	export class UpdateCommentDefaultLink {
		static readonly type = '[Comment] Update Comment Default Link';
		constructor(public data: { commentDefaultLink: JobCommentDefaultLinkDto; showSpinner?: boolean; showToast?: boolean } = { commentDefaultLink: null, showSpinner: false, showToast: false }) {}
	}

	export class UpdateCommentDefaultLinkSuccess {
		static readonly type = '[Comment] Update Comment Default Link Success';
		constructor(public commentData: JobCommentDefaultResponseAllDto) {}
	}

	export class UpdateCommentDefaultLinkError {
		static readonly type = '[Comment] Update Comment Default Link Error';
	}

	export class DeleteCommentDefaultLink {
		static readonly type = '[Comment] Delete Comment Default Link';
		constructor(public data: { commentDefaultLink: JobCommentDefaultLinkDto; showSpinner?: boolean; showToast?: boolean; showConfirm: boolean } = { commentDefaultLink: null, showSpinner: false, showToast: false, showConfirm: false }) {}
	}

	export class DeleteCommentDefaultLinkSuccess {
		static readonly type = '[Comment] Delete Comment Default Link Success';
		constructor(public commentData: JobCommentDefaultResponseAllDto) {}
	}

	export class DeleteCommentDefaultLinkError {
		static readonly type = '[Comment] Delete Comment Default Link Error';
	}
}
